import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import Navbar from './components/Navbar';
import StickyBanner from './components/StickyBanner';
import Home from './pages/Home';
import Leaderboard from './pages/Leaderboard';
import Admin from './pages/Admin';
import Profile from './pages/Profile';
import Login from './pages/Login';
import './styles/App.css';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <UserProvider>
          <BrowserRouter>
            <div className="app">
              <StickyBanner />
              <Navbar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/login" element={<Login />} />
                </Routes>
              </main>
            </div>
          </BrowserRouter>
        </UserProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
